import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyPage.css';

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>{t('privacyPolicy')}</h1>
        <div className="privacy-content">
          <section>
            <h2>{t('privacyIntroduction')}</h2>
            <p>{t('privacyIntroductionText')}</p>
          </section>

          <section>
            <h2>{t('dataCollection')}</h2>
            <p>{t('dataCollectionText')}</p>
            <ul>
              <li>{t('dataCollectionPoint1')}</li>
              <li>{t('dataCollectionPoint2')}</li>
              <li>{t('dataCollectionPoint3')}</li>
            </ul>
          </section>

          <section>
            <h2>{t('dataUsage')}</h2>
            <p>{t('dataUsageText')}</p>
          </section>

          <section>
            <h2>{t('dataProtection')}</h2>
            <p>{t('dataProtectionText')}</p>
          </section>

          <section>
            <h2>{t('userRights')}</h2>
            <p>{t('userRightsText')}</p>
            <ul>
              <li>{t('userRight1')}</li>
              <li>{t('userRight2')}</li>
              <li>{t('userRight3')}</li>
            </ul>
          </section>

          <section>
            <h2>{t('contactUs')}</h2>
            <p>{t('privacyContactText')}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage; 